export const locale = {
  dashboard_origin: "Tableau de bord",
  menu: "Menu",
  get_menu_again: "Récupérer le menu à nouveau",
  loading_error: {
    title: "Erreur de chargement !",
    message:
      "Une erreur s'est produite lors du chargement des données ! Veuillez réessayer",
    text: "Réessayer",
  },
  copy_right: {
    year: "1404",
    text1:
      "Tous les droits matériels et intellectuels de ce système sont réservés et appartiennent à la société de publicité",
    text2: "Entrepreneurs Supérieurs",
    text3: "Sepehr Arad. Toute copie entraînera des poursuites judiciaires.",
  },
  user: "Cher utilisateur",
  hi: "Bonjour",
  exit: "Déconnexion",
  go_to_page: "Aller à la page",
  show: "Afficher",
  until: "jusqu'à",
  from: "de",
  page: "Page",
  notes: "Notes",
  created_at: "Date de création",
  registration: "S'inscrire",
  edit_contact: "Modifier le contact",
  cancel: "Annuler",
  edit: "Modifier",
  delete: "Supprimer",
  contact_info: "Informations de contact",
  add_birthday: "Ajouter l'anniversaire",
  contacts: "Carnets d'adresses",
  last_updated_at: "Dernière modification",
  added_to_contact: "Ajouté aux contacts",
  contact_registered: "Votre contact n'a pas été enregistré.",
  transaction: "Transaction",
  write_message: "Écrire un message",
  note_title: "Titre de la note",
  create_note: "Ajouter une note",
  are_you_sure_to_delete: "Êtes-vous sûr de vouloir supprimer ?",
  last_transaction: "Dernières transactions",
  your_balance: "Votre solde",
  no_transaction: "Aucune transaction n'a encore été enregistrée pour vous !",
  increase_balance: "Augmenter le solde",
  transaction_list: "Liste des transactions",
  withdraw: "Retirer des fonds",
  decrease: "Retirer des fonds",
  deposit: "Déposer des fonds",
  increase: "Déposer des fonds",
  charge: "Recharger le portefeuille",
  refund: "Remboursement",
  save: "Enregistrer",
  reload: "Recharger la liste",
  shared: "Partagé",
  list: "Liste",
  single_add: "Ajouter un seul",
  mass_add: "Ajouter en masse",
  excel_add: "Ajouter depuis Excel",
  added_successfully: "Ajouté avec succès",
  error_add_phone: "Erreur lors de l'ajout du numéro",
  group: {
    add: "Ajouter un nouveau groupe",
    delete: "Supprimer le groupe",
    edit: "Modifier le groupe",
    first: "Veuillez d'abord ajouter un nouveau groupe.",
  },
  successfully_deleted: "Supprimé avec succès",
  notification: {
    text: "Notifications utilisateur",
    new: "Nouveau message",
    messages: "Messages",
    events: "Événements",
    no_new_message: "Aucun nouveau message !",
    show_all: "Afficher tout",
    no_new_event: "Aucun nouvel événement !",
    go_to_user: "Aller à l'utilisateur",
    watched: "Vu",
  },
  locking_for_service: "Quel service recherchez-vous ?",
  service_name: "Entrez le nom du service souhaité...",
  invite: {
    title: "Présentez le système à vos amis.",
    gift: "Cadeau",
    get: "Recevoir.",
    phone: "Entrez le numéro.",
    invite: "Inviter !",
    got_it: "Compris",
    get_gift: "Recevoir le cadeau",
    success: "Votre message d'invitation a été envoyé avec succès.",
    wrong_number: "Veuillez entrer un numéro valide.",
  },
  ticker: {
    text: "Nous sommes avec vous à chaque instant...",
    help: "Enregistrez un ticket pour contacter notre équipe de support",
    register: "Enregistrer un ticket",
  },
  package: {
    title: "Forfaits actifs",
    no: "Vous n'avez aucun forfait actif.",
    no_limit: "Panneau illimité",
    day: " jours",
    other: " restant",
    expiration: "Expiration ",
    expired: " Expiré ",
  },
  Loading: {
    Waiting: "Veuillez patienter",
    Description: "Un instant",
  },
  Questions: {
    Yes: "Oui",
    No: "Non",
  },
  Success: {
    Title: "Succès",
    defaultActionText: "Compris",
  },
  Info: {
    Title: "Information",
    defaultActionText: "Compris",
  },
  Warning: {
    Title: "Avertissement",
    defaultActionText: "Compris",
  },
  Error: {
    Title: "Erreur",
    defaultActionText: "Compris",
  },
  Wallet: {
    Title: "Solde insuffisant",
    defaultActionText: "Compris",
  },
  ConnectionLost: {
    Title: "Votre connexion internet est perdue",
    Subtitle: "Veuillez vérifier votre connexion internet",
    Button: "Réessayer",
  },
  emoji: "Émoji",
  text_suggest_free: "Consultant de texte (gratuit)",
  select_campaign: "Sélectionner la campagne",
  short_link: "Lien court",
  text_suggest: "Consultant de texte",
  select_emoji: "Sélectionner l'émoji",
  default_text: "Texte par défaut",
  emoji_group: {
    "Smileys & Emotion": "Smileys & Émotions",
    "People & Body": "Personnes & Corps",
    "Animals & Nature": "Animaux & Nature",
    "Food & Drink": "Nourriture & Boissons",
    "Travel & Places": "Voyages & Lieux",
    Activities: "Activités",
    Objects: "Objets",
    Symbols: "Symboles",
    Flags: "Drapeaux",
  },
  table: {
    index: "Ligne",
    title: "Titre",
    text: "Texte",
    select: "Sélectionner",
    next: "Suivant",
    previous: "Précédent",
    rows_per_page: "Lignes par page",
    no_data: "Aucune donnée à afficher",
    search_placeholder: "Rechercher",
  },
  modal: {
    success: "Succès",
  },
  actions: {
    remove: "Supprimer",
    copyLink: "Copier le lien",
    operations: "Opérations",
    edit: "Modifier",
    delete: "Supprimer",
    show: "Afficher",
    accept: "Approuver",
    reject: "Rejeter",
    enable: "Activer",
    download: "Télécharger",
    deactive: "Désactiver",
  },

  shortLink: {
    freeShorten: 'Raccourcissez vos liens "gratuitement".',
    clickToSelect: "Cliquez sur le lien souhaité pour le sélectionner.",
    create: "Créer un lien court",
    title: "Titre",
    titleHint: "Veuillez ajouter un nom pour votre lien court.",
    link: "Lien",
    linkHint: "Entrez votre lien souhaité.",
    shortenedLink: "Lien raccourci",
    clickCount: "Nombre de clics",
    selectDomain: "Sélectionner le domaine",
  },
  pagination: {
    next: "Suivant",
    previous: "Précédent",
    rowsPerPage: "Lignes par page",
    noData: "Aucune donnée à afficher",
    search: "Rechercher",
  },
  validation: {
    titleRequired: "Le titre est requis",
    minLength4: "Minimum 4 caractères autorisés",
    linkRequired: "Le lien est requis",
    mustIncludeHttps: "Doit inclure https://",
    invalidLink: "Veuillez entrer un lien valide.",
  },
  messages: {
    addedSuccessfully: "Ajouté avec succès.",
    confirmDeleteShortLink: "Confirmer la suppression du lien court ?",
  },
  inputMenu: {
    text: "Texte",
    selectUserInfo: "Sélectionner les détails de l'utilisateur",
  },
  patternDialog: {
    title: "Sélectionner le modèle/campagne",
    change: "Changer le modèle/campagne",
    createPattern: "Enregistrer un nouveau modèle",
    createCampaign: "Enregistrer une nouvelle campagne",
    tabs: {
      pattern: "Sélectionner le modèle",
      campaign: "Sélectionner la campagne",
    },
    empty: "Aucun modèle trouvé, veuillez d'abord enregistrer un modèle.",
    columns: {
      id: "ID",
      type: "Type",
      pattern: "Modèle",
      static: "Statique",
      title: "Titre",
      content: "Texte",
      status: "Statut",
      rejected: "Rejeté",
      approved: "Approuvé",
    },
    pagination: {
      next: "Suivant",
      prev: "Précédent",
      rowsPerPage: "Lignes par page",
      noData: "Aucune donnée à afficher",
      search: "Rechercher",
    },
  },
  PATTERN: {
    SELECTED_MESSAGE: "Message sélectionné :",
    REQUIRED_INPUTS: "Entrées requises :",
    SELECTED_CAMPAIGN: "Campagne sélectionnée :",
    CAMPAIGN_ID: "ID",
    PRE_NAME: "Préfixe",
    NAME: "Nom",
    MIDDLE_NAME: "Deuxième nom",
    LAST_NAME: "Nom de famille",
    POST_NAME: "Suffixe",
    ALIAS: "Alias",
    COMPANY: "Entreprise",
    JOB_TITLE: "Titre du poste",
    PHONE: "Numéro de téléphone",
    BIRTHDAY: "Anniversaire",
    DESCRIPTION: "Description",
  },
  CONTACT_GROUP: {
    LIST: "Liste",
    ADD: "Ajouter",
    SEARCH: "Rechercher",
    INDEX: "Ligne",
    ID: "ID",
    GROUP_NAME: "Nom du groupe",
    PARENT: "Parent",
    CREATE: {
      GROUP_NAME: "Nom de groupe par défaut",
      PARENT_CATEGORY: "Catégorie parente",
      ADD_GROUP: "Ajouter un groupe",
      SUCCESS: "Groupe par défaut ajouté avec succès.",
      ERROR: "Erreur lors de l'ajout du groupe par défaut !",
      SEARCH: "Rechercher",
      TITLE: "Titre",
      SEARCH_IN_TITLE: "Rechercher dans le titre",
      FROM: "De",
      TO: "À",
      BIRTHDAY_FROM: "Anniversaire de",
      BIRTHDAY_TO: "À la date",
      ITEMS_PER_PAGE: "Éléments par page",
      PHONE_COPY: "Copier le numéro",
      COPY_PHONE: "Copier le numéro",
      DELETE_CONTACT_GROUP: "Supprimer le contact du groupe",
      DELETE_FROM_GROUP_ONLY: "Supprimer le contact uniquement de ce groupe",
      DELETE_FROM_ALL_GROUPS: "Supprimer le contact de tous les groupes",
      USER: "Utilisateur",
      PHOTO: "Photo",
      FULL_NAME: "Nom complet",
      EMAIL: "E-mail",
      PHONE_NUMBER: "Numéro de portable",
      JOB_TITLE_COMPANY: "Titre du poste et entreprise",
      CREATED_AT: "Heure de création",
      PHONEBOOK: "Carnet d'adresses",
      ACTIONS: "Actions",
    },
    TITLE: "Titre",
    SEARCH_IN_TITLE: "Rechercher dans le titre",
    FROM: "De",
    TO: "À",
    BIRTHDAY_FROM: "Anniversaire de",
    BIRTHDAY_TO: "À la date",
    ITEMS_PER_PAGE: "Éléments par page",
    PHONE_COPY: "Copier le numéro",
    COPY_PHONE: "Copier le numéro",
    DELETE_CONTACT_GROUP: "Supprimer le contact du groupe",
    DELETE_FROM_GROUP_ONLY: "Supprimer le contact uniquement de ce groupe",
    DELETE_FROM_ALL_GROUPS: "Supprimer le contact de tous les groupes",
    USER: "Utilisateur",
    PHOTO: "Photo",
    FULL_NAME: "Nom complet",
    EMAIL: "E-mail",
    PHONE_NUMBER: "Numéro de portable",
    JOB_TITLE_COMPANY: "Titre du poste et entreprise",
    CREATED_AT: "Heure de création",
    PHONEBOOK: "Carnet d'adresses",
    ACTIONS: "Actions",
  },
  GRADUAL: {
    SEND_GRADUAL: "Envoi progressif",
    ALLOWED_HINT: "Pour l'envoi à plus de 500 numéros",
    SEND_GRADUAL_OPTION: "Envoyer progressivement",
    AFTER_EVERY: "Après chaque",
    SEND_SMS: "messages doivent être envoyés ?",
    TIME_INTERVAL: "Intervalle de temps",
    SMS_PART: "Nombre de messages",
    SMS_PART_HINT: "Entrez le nombre de messages par lot.",
    COUNT_ERROR:
      "Le nombre de messages par lot ne peut pas être inférieur à 500 !",
  },
  HISTORY: {
    CREATE_NEW: "Créer un nouvel historique",
    BACK: "Retour",
    TITLE: "Titre de l'historique",
    STEP: "Étape",
    LAST_CALL: "Heure du dernier appel",
    DISCUSSIONS: "Discussions tenues",
    REMIND_DATE: "Heure de rappel",
    FOLLOWUP: "Éléments de suivi pour l'appel suivant",
    SAVE_HISTORY: "Enregistrer l'historique",
    INDEX: "Ligne",
    SAVED_BY: "Enregistré par",
    ACTION: "Gestion",
    MORE_INFO: "Plus d'informations sur",
    CREATE_ERROR: "Erreur lors de l'ajout de l'historique client !",
  },
  FORMS: {
    SourceNumber: "Numéro source",
    DestinationPhone: "Numéro de destination",
    Add: "Ajouter",
    SEND_TO_SELECTED_NUMBERS: "Envoyer aux numéros sélectionnés",
    CHANGE_PATTERN_CAMPAIGN: "Changer le modèle/campagne",
    SendTime: "Heure d'envoi",
    SELECTED_MESSAGE: "Message sélectionné",
    REQUIRED_INPUTS: "Entrées requises",
    SELECTED: "Sélectionné",
    ID: "ID",
    SEND: "Envoyer",
    DATE_REQUIRED: "La sélection de la date est requise.",
    TIME_INTERVAL: "Intervalle de temps",
    TIME_INTERVAL_FROM_PREVIOUS:
      "Intervalle de temps par rapport au message précédent",
    Title: "Titre",
    LINK: "Lien",
    LINK_HINT: "n'importe quel",
    LINK_PLACEHOLDER: "Exemple :[](https://example.ex/any)",
    LINK_SHORTENED_HINT:
      "Votre lien sera raccourci à 14 caractères et remplacé dans le texte (example.ex/any), avec un lien unique pour chaque message.",
    Text: "Texte",
    MUST_INCLUDE_PATTERN: "Doit inclure la phrase {pattern}",
    INVALID_LINK: "Entrez un lien valide",
  },
  ERRORS: {
    VpnDetectedTitle: "Désactivez votre VPN",
    VpnDetectedSubtitle:
      "Cela aidera le système à fonctionner mieux et vous offrira une expérience plus fluide.",
    PhoneIsNotValid: "Le numéro de téléphone n'est pas valide",
    MaxPhoneLimit: "Vous ne pouvez pas ajouter plus de 50 000 numéros.",
    NoSelectedLineNumber: "Aucun numéro source sélectionné.",
    INVALID_TIMER: "Entrez une heure valide",
    NoAccess: "Vous n'avez pas d'accès",
    PleaseBuyAPlane: "Veuillez acheter un forfait",
    NoAccountCharge: "Solde du compte insuffisant",
    PleaseChargeYourAccount: "Veuillez recharger votre compte",
    Unauthorized: "Accès refusé : Veuillez vous reconnecter",
    ServerError: "Erreur serveur, veuillez réessayer plus tard",
    NetworkError: "Erreur réseau : Veuillez vérifier votre connexion internet",
    InvalidInput: "Entrée invalide",
    SessionExpired: "Votre session a expiré, veuillez vous reconnecter",
    TokenInvalid: "Token invalide",
    VpnDetected: "Votre VPN est actif, veuillez le désactiver",
    RequestTimeout: "Votre demande a expiré, veuillez réessayer",
    DuplicateEntry: "Cet élément est déjà enregistré",
  },

  BUTTONS: {
    DELETE_NUMBERS: "Supprimer les numéros",
    ADD_BULK: "Ajouter en masse",
    FROM_FILE: "Depuis le fichier",
    More: "Plus",
    BuyAPlane: "Acheter un forfait",
    AccountCharge: "Recharger le compte",
    OK: "OK",
    Close: "Fermer",
    Cancel: "Annuler",
    Retry: "Réessayer",
    Login: "Connexion",
    Logout: "Déconnexion",
    Save: "Enregistrer",
    Submit: "Soumettre",
  },
  GENERAL: {
    row: "Ligne",
    id: "ID",
    back: "Retour",
    manage: "Gérer",
    SENDING: "Envoi",
    RELOAD: "Recharger",
    PRINT: "Imprimer",
    DELETE: "Supprimer",
    SUBMIT: "Soumettre",
    SUCCESSFULLY_ADDED: "Ajouté avec succès",
    CANCEL: "Annuler",
    SUCCESSFULLY_DOWNLOADED: "Téléchargé avec succès",
    Loading: "Chargement...",
    NoData: "Aucune donnée trouvée",
    Welcome: "Bienvenue",
    Profile: "Profil",
    Settings: "Paramètres",
    Wallet: "Portefeuille",
    Dashboard: "Tableau de bord",
  },

  NOTICES: {
    Attention: "Veuillez noter",
    MinimumSendWarning:
      'Lors de l\'envoi de SMS avec le numéro source "News", le nombre minimum doit être {{number}}.',
  },
  contactsTags: {
    select_group: "Sélectionner le groupe",
    create_group: "Créer un groupe",
    search: "Rechercher",
    add_group: "Ajouter un groupe",
    enter_group_name: "Entrez le nom souhaité",
    group_name: "Nom du groupe",
    cancel: "Annuler",
    edit: "Modifier",
    save: "Enregistrer",
    loading_categories: "Chargement des catégories...",
    select_group_and_subgroup: "Sélectionner le groupe et le sous-groupe",
    add_group_with_subgroups: "Ajouter un groupe avec sous-groupes",
    add_group_only: "Ajouter uniquement le groupe sélectionné",
    duplicate_name_error: "Nom en double",
    added_successfully: "Ajouté avec succès.",
    confirm_delete_group: "Confirmer la suppression du groupe ?",
    deleted_successfully: "Supprimé avec succès",
    edited_successfully: "Modifié avec succès",
    group_added_successfully: "Groupe(s) sélectionné(s) ajouté(s) avec succès.",
    error_creating_group: "Erreur lors de la création du groupe par défaut",
    create_default_group: "Créer un groupe par défaut",
    select_default_group: "Sélectionner le groupe par défaut",
    add_custom_group: "Ajouter un groupe avec nom personnalisé",
  },
  CONTACT_SHARE: {
    ADD_PHONE_NUMBER: "Ajouter un numéro de téléphone",
    ADD: "Ajouter",
    SHARE_ACCESS:
      "En sélectionnant l'une des options ci-dessous, partagez l'accès souhaité avec d'autres.",
    SELECT_ACCESS: "Sélectionner l'accès pour le carnet d'adresses",
    DELETE: "Supprimer",
    EDIT: "Modifier",
    SEND: "Envoyer",
    PERSONS_WITH_ACCESS: "Personnes avec accès",
    REMOVE_ACCESS: "Supprimer l'accès",
    RETURN: "Retour",
    SAVE_CHANGES: "Enregistrer les modifications",
    SHARE_CONTACT_BOOK: "Partager le carnet d'adresses",
    PHONE_VALIDATION: "Entrez un numéro de téléphone valide",
    SUCCESS_SHARE: "Carnet d'adresses partagé avec succès.",
    ERROR_SHARE: "Erreur lors du partage du carnet d'adresses !",
    PHONE_DUPLICATE: "Numéro déjà entré !",
    CHANGES_SAVED: "Modifications enregistrées avec succès.",
    ERROR_SAVING_CHANGES: "Erreur lors de l'enregistrement des modifications !",
  },
  CONTACT_SEARCH: {
    SEARCH: "Rechercher",
    ADD_NUMBER: "Ajouter un numéro",
  },
  CONTACT_PAGINATION: {
    PER_PAGE: "Par page",
    FROM: "De",
    TO: "À",
    TOTAL: "Total",
  },
  SUCCESS: {
    DELETED: "Supprimé avec succès",
    SUCCESS: "Succès",
  },
  CONFIRM: {
    DELETE_BULK: "Supprimer les numéros non enregistrés ?",
  },
  TOOLTIP: {
    CopyPhoneNumbers: "Copiez vos numéros puis cliquez",
    COPY_LINK: "Copier le lien",
    COPY_NUMBER: "Copier le numéro",
    SEE_PROFILE: "Voir le profil",
  },
  CONTACT_EDIT: {
    EDIT: "Modifier",
    DELETE: "Supprimer",
  },
  CONTACT_MENU: {
    SHARE: "Partager",
    PRINT: "Imprimer",
    EXCEL_EXPORT: "Exporter vers Excel",
    DELETE: "Supprimer",
    SUCCESS_DELETE: "Supprimé avec succès.",
    ERROR_DELETE: "Erreur lors de la suppression des contacts !",
  },
  CONTACTS: {
    PREFIX: "Préfixe",
    NAME: "Nom",
    MIDDLENAME: "Deuxième nom",
    LASTNAME: "Nom de famille",
    POSTFIX: "Suffixe",
    ALIAS: "Alias",
    COMPANY: "Entreprise",
    JOBTITLE: "Titre du poste",
    PHONE: "Numéro de téléphone",
    PHONE_PLACEHOLDER: "ex. 8070 111 13 (989)(989+)(9)(09)",
    ADD_EMAIL: "Ajouter un e-mail",
    EMAIL: "E-mail",
    ADD_ADDRESS: "Ajouter une adresse",
    ADDRESS: "Adresse",
    PROVINCE: "Province",
    CITY: "Ville",
    POSTALCODE: "Code postal",
    YEAR_OPTIONAL: "Année (optionnel)",
    MONTH: "Mois",
    DAY: "Jour",
    ADD_BIRTHDAY: "Ajouter l'anniversaire",
    ADD_WEBSITE: "Ajouter un site web",
    WEBSITE: "Site web",
    ADD_DATE: "Ajouter une date",
    DATE: "Date",
    CUSTOM_FIELD: "Champ personnalisé",
    ADD_CUSTOM_FIELD: "Ajouter un champ personnalisé",
    NOTE: "Notes",
    ADD_NOTE: "Ajouter une note",
    HOME: "Domicile",
    WORK: "Travail",
    OTHER: "Autre",
    PROFILE: "Profil",
    BLOG: "Blog",
    HOMEPAGE: "Page d'accueil",
    TITLE: "Titre",
    BIRTHDAY_ERROR: "Entrez la date correctement",
    YEAR_ERROR: "4 chiffres",
    EMAIL_ERROR: "Entrez l'e-mail correctement",
    WEBSITE_ERROR: "Entrez le lien correctement (website.com)",
    PHONE_ERROR: "Entrez un numéro de téléphone valide",
    ADD_HISTORY: "Ajouter un historique",
    HISTORY_LIST: "Liste d'historique",
    EDIT_CONTACT: "Modifier le contact",
    SHOW_CONTACT: "Afficher le contact",
  },
  MONTHS: {
    FARVARDIN: "Farvardin",
    ORDIBEHESHT: "Ordibehesht",
    KHORDAD: "Khordad",
    TIR: "Tir",
    MORDAD: "Mordad",
    SHAHRIVAR: "Shahrivar",
    MEHR: "Mehr",
    ABAN: "Aban",
    AZAR: "Azar",
    DEY: "Dey",
    BAHMAN: "Bahman",
    ESFAND: "Esfand",
  },

  UPLOAD_EXCEL: {
    DOWNLOAD_SAMPLE: "Téléchargez et utilisez le fichier Excel exemple",
    UPLOAD_TITLE: "Télécharger le fichier",
    DRAG_DROP_TEXT_PART1: "Glissez-déposez pour télécharger ou",
    DRAG_DROP_TEXT_PART2: "ici",
    DRAG_DROP_TEXT_PART3: "cliquez",
    FILE_INPUT_LABEL: "Télécharger le fichier Excel",
  },
  SUCCESS_MESSAGE: {
    LINK_COPIED: "Lien copié avec succès !",
  },
  ERROR_MESSAGE: {
    COPY_LINK_FAILED: "Erreur lors de la copie du lien.",
  },
  POPUP: {
    TITLE_OR_BUTTON_TEXT: "Sélectionner le modèle/campagne",
    BUTTON_EDIT_TEXT: "Changer le modèle/campagne",
  },
  BUTTON: {
    REGISTER_NEW_PATTERN: "Enregistrer un nouveau modèle",
    REGISTER_NEW_CAMPAIGN: "Enregistrer une nouvelle campagne",
    CREATE_NEW_HISTORY: "Créer un nouvel historique",
    SAVE_HISTORY: "Enregistrer l'historique",
    SELECT_GROUP: "Sélectionner le groupe",
    CREATE_GROUP: "Créer un groupe",
    ADD_GROUP: "Ajouter un groupe",
    SAVE: "Enregistrer",
    CREATE_GROUP_SINGULAR: "Créer un groupe",
    ADD: "Ajouter",
    SEND: "Envoyer",
    EDIT_PERMISSIONS: "Modifier",
    GO_BACK: "Retour",
    SAVE_CHANGES: "Enregistrer les modifications",
    GUIDE: "Guide",
    START: "Démarrer",
    EDIT: "Modifier",
    CANCEL: "Annuler",
    AUTO_REFRESH: "Actualisation automatique",
    AUTO_REFRESH_SETTINGS: "Paramètres d'actualisation automatique",
    BACK: "Retour",
  },
  TABS: {
    SELECT_PATTERN: "Sélectionner le modèle",
    SELECT_CAMPAIGN: "Sélectionner la campagne",
    LIST: "Liste",
    ADD: "Ajouter",
    ADD_CUSTOM_GROUP: "Ajouter un groupe avec nom personnalisé",
    SELECT_DEFAULT_GROUP: "Sélectionner le groupe par défaut",
  },
  NO_DATA: {
    NO_PATTERN: "Aucun modèle trouvé, veuillez d'abord enregistrer un modèle.",
  },
  TABLE: {
    ID: "ID",
    TYPE: "Type",
    PATTERN: "Modèle",
    STATIC: "Statique",
    TITLE: "Titre",
    TEXT: "Texte",
    STATUS: "Statut",
    REJECTED: "Rejeté",
    ACCEPTED: "Approuvé",
    NEXT_BUTTON: "Suivant",
    PREVIOUS_BUTTON: "Précédent",
    ROWS_PER_PAGE_TEXT: "Lignes par page",
    NO_DATA_TEXT: "Aucune donnée à afficher",
    PLACEHOLDER_SEARCH: "Rechercher",
    MORE_INFO_ABOUT_ITEM: "Plus d'informations sur {name}",
  },
  MENU_ITEMS: {
    TEXT_INPUT: "Texte",
    SELECT_USER_INFO: "Sélectionner les détails de l'utilisateur",
  },
  TABLE_CONTROLS: {
    COUNT: "Nombre",
    SEARCH: "Rechercher",
  },
  FORM_LABELS: {
    DEFAULT_GROUP_NAME: "Nom de groupe par défaut",
    PARENT_CATEGORY: "Catégorie parente",
    HISTORY_TITLE: "Titre de l'historique",
    STEP: "Étape",
    LAST_CALL_TIME: "Heure du dernier appel",
    NEGOTIATIONS: "Négociations tenues",
    REMINDER_TIME: "Heure de rappel",
    FOLLOW_UP_ITEMS: "Éléments de suivi pour l'appel suivant",
    GROUP_NAME: "Nom du groupe",
    SEARCH: "Rechercher",
    TITLE: "Titre",
    SEARCH_IN_TITLE: "Rechercher dans le titre",
    FROM: "De",
    TO: "À",
    BIRTHDAY_FROM: "Anniversaire de",
    BIRTHDAY_TO: "À la date",
    COUNT: "Nombre",
    ADD_PHONE_NUMBER: "Ajouter un numéro de téléphone",
  },
  TOAST: {
    Success: "Opération terminée avec succès",
    Error: "Une erreur s'est produite",
    Warning: "Avertissement : Veuillez vérifier les entrées",
    AUTO_REFRESH_STARTED: "Actualisation automatique démarrée.",
    DEFAULT_GROUP_SUCCESS: "Groupe par défaut ajouté avec succès.",
    DEFAULT_GROUP_ERROR: "Erreur lors de l'ajout du groupe par défaut !",
    ADD_HISTORY_ERROR: "Erreur lors de l'ajout de l'historique client !",
    DUPLICATE_NAME: "Nom en double",
    TAG_ADDED_SUCCESS: "Étiquette ajoutée avec succès.",
    TAG_DELETED_SUCCESS: "Étiquette supprimée avec succès.",
    TAG_EDITED_SUCCESS: "Étiquette modifiée avec succès.",
    GROUPS_ADDED_SUCCESS: "Groupe(s) sélectionné(s) ajouté(s) avec succès.",
    ADD_GROUP_ERROR: "Erreur lors de l'ajout du groupe par défaut !",
    PHONE_COPIED_SUCCESS: "Numéro de portable copié.",
    SUCCESSFULLY_DELETED: "Supprimé avec succès",
    ERROR_DELETING_CONTACT_FROM_PHONEBOOK:
      "Erreur lors de la suppression du contact du carnet d'adresses !",
    SHARE_SUCCESS: "Carnet d'adresses partagé avec succès.",
    SHARE_ERROR: "Erreur lors du partage du carnet d'adresses !",
    NUMBER_ALREADY_ADDED: "Numéro déjà entré !",
    CHANGES_SAVED_SUCCESS: "Modifications enregistrées avec succès.",
    CHANGES_SAVE_ERROR: "Erreur lors de l'enregistrement des modifications !",
  },
  HEADERS: {
    GRADUAL_SEND: "Envoi progressif",
    GRADUAL_SEND_HINT: "(Pour l'envoi à plus de 500 numéros)",
  },
  CHECKBOX_LABELS: {
    GRADUAL_SENDING: "Envoyer progressivement",
    DELETE: "Supprimer",
    EDIT: "Modifier",
    ADD: "Ajouter",
  },
  MESSAGES: {
    SENDING_INTERVAL_QUESTION:
      "Après chaque {time} messages doivent être envoyés ?",
  },
  LABELS: {
    TIME_INTERVAL: "Intervalle de temps",
    MESSAGE_COUNT: "Nombre de messages",
  },
  TIME_TYPES: {
    MINUTE: "Minute",
    HOUR: "Heure",
    DAY: "Jour",
    WEEK: "Semaine",
    SECOND: "Seconde",
  },
  HINTS: {
    MESSAGE_COUNT_PER_PART: "Entrez le nombre de messages par lot.",
  },
  RULES: {
    MESSAGE_COUNT_MIN_LIMIT:
      "Le nombre de messages par lot ne peut pas être inférieur à 500 !",
  },
  TABLE_HEADERS: {
    ROW: "Ligne",
    TITLE: "Titre",
    STEP: "Étape",
    REMINDER_TIME: "Heure de rappel",
    LAST_CALL_TIME: "Heure du dernier appel",
    RECORDER: "Enregistreur",
    MANAGEMENT: "Gestion",
    ID: "ID",
    GROUP_NAME: "Nom du groupe",
    PARENT: "Parent",
    CREATED_AT: "Créé",
    IMAGE: "Image",
    FULL_NAME: "Nom complet",
    EMAIL: "E-mail",
    PHONE_NUMBER: "Numéro de portable",
    JOB_COMPANY: "Titre du poste et entreprise",
    CREATION_TIME: "Heure de création",
    PHONEBOOK: "Carnet d'adresses",
    ACTIONS: "Actions",
    USER: "Utilisateur",
  },
  PROPS: {
    SOURCE_NUMBER_LABEL: "Numéro source",
  },
  MODAL: {
    INFO_TITLE: "Veuillez noter.",
    INFO_MESSAGE_NEWS_NUMBER:
      'Lors de l\'envoi de SMS avec le numéro source "{number}", le nombre minimum doit être 1000.',
    CONFIRM_DELETE_GROUP: "Confirmer la suppression du groupe ?",
  },
  SPECIAL_NUMBERS: {
    NEWS_SEND: "Envoi de nouvelles",
  },
  POPUP_TITLES: {
    SYSTEM_GUIDE: "Guide du système",
    ERROR: "Erreur",
    WARNING: "Avertissement",
    SUCCESS: "Succès",
    CONFIRM: "Confirmer",
    SELECT_GROUP: "Sélectionner le groupe",
    CREATE_NEW_GROUP: "Créer un nouveau groupe",
    SELECT_GROUP_SUBGROUP: "Sélectionner le groupe et le sous-groupe",
    CREATE_DEFAULT_GROUP: "Créer un groupe par défaut",
    DELETE_CONTACT_FROM_GROUP: "Supprimer le contact du groupe",
    DELETE_CONTACT: "Supprimer le contact",
    SHARE_PHONEBOOK: "Partager le carnet d'adresses",
    SYSTEM_GUIDE: "Guide du système de publicité terminal",
  },
  CARD_TITLES: {
    ENTER_GROUP_NAME: "Entrez le nom souhaité",
    SELECT_PERMISSIONS:
      "Sélectionner l'accès pour le carnet d'adresses {name} :",
    PEOPLE_WITH_ACCESS: "Personnes avec accès",
  },
  LOADING_MESSAGES: {
    FETCHING_CATEGORIES: "Chargement des catégories...",
  },
  RADIO_LABELS: {
    GROUP_WITH_SUBGROUPS: "Ajouter un groupe avec sous-groupes",
    SELECTED_GROUP_ONLY: "Ajouter uniquement le groupe sélectionné",
    DELETE_FROM_THIS_GROUP_ONLY: "Supprimer le contact uniquement de ce groupe",
    DELETE_FROM_ALL_GROUPS: "Supprimer le contact de tous les groupes",
  },
  FILTER_LABELS: {
    ADDRESS: "Adresse",
    EMAIL: "E-mail",
    WEBSITE: "Site web",
    CUSTOM_FIELD: "Champ personnalisé",
    DATE: "Date",
  },
  CARD_SUBTITLES: {
    SHARE_INSTRUCTION:
      "En sélectionnant l'une des options ci-dessous, partagez l'accès souhaité avec d'autres.",
  },
  VALIDATION: {
    INVALID_PHONE_NUMBER: "Entrez un numéro de téléphone valide",
  },
  LIST_ITEM_TITLES: {
    DELETE: "Supprimer",
    EDIT: "Modifier",
    ADD: "Ajouter",
    REMOVE_ACCESS: "Supprimer l'accès",
  },
  CAMPAIGN: {
    CAMPAIGN_NAME: "Nom de la campagne",
    TEXT: "Texte",
    MESSAGE: "Message",
    FOR: "Pour",
    SELECT_CAMPAIGN: "Sélectionner la campagne",
    CLICK_ROW: "Cliquez sur la ligne souhaitée.",
    NEW: "Nouveau",
    SUBMIT_CAMPAIGN: "Enregistrer la campagne",
    TIME: "Heure",
    MESSAGE_COUNT: "Nombre de messages",
    PAGE_COUNT: "Nombre total de messages (pages)",
    PAGE: "Page",
    CANCEL_TEXT: "Annuler11",
    TRACKABLE_LINK: "Lien traçable",
    WARNING_TEXT:
      "Veuillez corriger le(s) texte(s) de la campagne sélectionnée !",
    WARNING_TITLE:
      "Veuillez corriger le(s) titre(s) de la campagne sélectionnée !",
    WARNING_GAP:
      "Veuillez corriger l'(les) intervalle(s) de temps de la campagne sélectionnée !",
    WARNING_OPERATOR:
      "Veuillez corriger l'(les) opérateur(s) de la campagne sélectionnée !",
    MAX_ITEMS_ERROR: "Maximum 10 éléments peuvent être ajoutés.",
  },
  ADS: {
    LIVE_SMS: "Envoi SMS en direct",
    BUY_JOB_DB: "Acheter la base de données d'emplois",
    SMART_LADDER: "Échelle d'annonces Divar intelligente",
    JOB_SMS: "Envoyer SMS aux entreprises",
    WEB_DESIGN: "Commander la conception de site web",
    SEO: "Commander le SEO",
    MAP_SMS: "Envoyer SMS depuis la carte",
    GRADUAL_LADDER: "Échelle d'annonces Divar progressive",
    SEO_ALT: "Commander le SEO",
    SITE_SUPPORT: "Gestion et support de site web",
    CITY_SMS: "Envoyer SMS à la ville et à la province",
    AUTO_CHAT: "Chat automatique Divar",
  },
  TUTORIALS: {
    WHATSAPP_SUPPORT: "Support WhatsApp",
    TICKET_SUPPORT: "Enregistrer un ticket",
  },
  INCREASE: {
    PAN: "Numéro de carte",
    CVV2: "CVV2",
    MONTH: "Mois",
    YEAR: "Année",
    PIN2: "Mot de passe secondaire",
    GET_OTP: "Recevoir l'OTP",
    PAY: "Payer",
    INVALID_PAN: "Le numéro de carte est incorrect",
    INVALID_CVV2: "Le CVV2 est incorrect",
  },
  WALLET: {
    CustomCharge: "Recharger le portefeuille",
    withdrawTitle: "Retirer du portefeuille",
    transactionListTooltip: "Votre liste de transactions",
    reloadTooltip: "Recharger",
    withdrawTooltip: "Retirer du portefeuille",
    AmountLabel: "Crédit ",
    SelectAmount: "Sélectionner le montant",
    Amount: "Montant",
    Currency: "Rial",
    GateWay: "Passerelle de paiement",
    noGateWay: "Aucune passerelle trouvée",
    Pay: "Payer",
    PriceNotInRange: "Le montant doit être entre {min} et {max}.",
    ErrorOnRedirectToGateWay:
      "Erreur lors de la redirection vers la passerelle de paiement",
    ErrorGeneral: "Erreur",
    MinAmountError: "Le montant entré est inférieur au minimum autorisé.",
    MinBazarAmountError:
      "Le montant ne peut pas être inférieur à 10 000 Tomans !",
    BazarSuccessInfo:
      "En cas de paiement réussi, il faut 1 à 3 minutes pour que votre portefeuille soit rechargé.",
    withdrawableBalance: "Solde retirable",
    withdrawFee: "Frais de retrait : 50 000 Rials !",
    selectAccount: "Sélectionner le compte",
    addAccount: "Ajouter un compte",
    submitWithdraw: "Soumettre le retrait",
    accountRequiredInfo: "Toutes les informations sont requises.",
    ownerName: "Nom du propriétaire du compte",
    ownerLastName: "Nom de famille",
    bankName: "Nom de la banque",
    accountNumber: "Numéro de compte",
    cardNumber: "Numéro de carte",
    sheba: "Numéro Sheba",
    onlyPersian: "Seules les lettres persanes sont autorisées !",
    cardNumberLength: "Le numéro de carte doit comporter 16 chiffres !",
    shebaLength: "Le numéro Sheba doit comporter 24 chiffres !",
  },
  USER_PICKER: {
    SELECT_USER: "Sélectionner l'utilisateur",
    SELECT_USERS: "Sélectionner les utilisateurs",
    SEARCH: "Rechercher",
    PERSON: "Particulier",
    COMPANY: "Entité juridique",
    ID: "ID",
    NAME: "Nom",
    LASTNAME: "Nom de famille",
    USERNAME: "Nom d'utilisateur",
    PHONE: "Numéro de portable",
    TYPE: "Type d'utilisateur",
  },
  NEWS: {
    TITLE: "Nouvelles de SMS Land",
    VIEW_BUTTON: "Voir",
    NO_NEWS: "Aucune nouvelle récente.",
    FETCH_ERROR: "Erreur lors de la récupération des nouvelles !",
  },
  MENUS: {
    CONTACT_LIST: "Liste de contacts",
    FINDPREFIX: "Rechercher le préfixe",
    // Systems
    TICKET_REGISTRATION: "Enregistrer un ticket",
    AD_TERMINAL_SYSTEM: "Système de publicité terminal",
    WALLET_TRANSACTIONS: "Transactions du portefeuille",
    DYNAMIC_QR_SYSTEM: "Système de création de QR dynamique",
    DIVAR_AD_SYSTEM: "Système de soumission et de gestion d'annonces Divar",
    GRAPHIC_DESIGN_SYSTEM:
      "Système de commande de conception graphique et d'impression",
    DIGITAL_MARKETING_SYSTEM: "Système de gestion du marketing numérique",
    BULK_SMS_SYSTEM: "Système SMS en masse",
    BUSINESS_INFO_SYSTEM:
      "Système de base de données d'informations commerciales nationales",
    AD_MANAGEMENT_SYSTEM: "Système de gestion des annonces",
    GRAPHIC_VIDEO_SERVICES:
      "Système de services de conception graphique et vidéo",
    // QR Tools
    QR_TOOL: "Outils QR",
    CREATE_DYNAMIC_QR: "Créer un QR dynamique",
    QR_MANAGEMENT: "Gestion QR",
    QR_MONITORING: "Surveillance QR",
    MY_QR_LIST: "Ma liste QR",
    PHYSICAL_NFC_ORDERS: "Commandes de cartes physiques et NFC",
    BULK_QR_GENERATION: "Génération de QR en masse",
    IMAGE_CREATION_TOKEN: "Token de création d'image",
    QR_SMS: "QR SMS",
    QR_LINK: "QR Lien",
    QR_TEXT: "QR Texte",
    QR_LOCATION: "QR Emplacement",
    QR_EMAIL: "QR E-mail",
    QR_CALL: "QR Appel",
    QR_WIFI: "QR WiFi",
    VISIT_STATISTICS: "Statistiques de visites",
    // Ad Management
    AD_MONITORING: "Surveillance des annonces",
    DIVAR_NEWS: "Mises à jour Divar",
    REAL_ESTATE_AD_SUBMISSION: "Soumission d'annonces immobilières",
    AUTO_AD_RENEWAL: "Renouvellement automatique des annonces",
    GRADUAL_AD_SUBMISSION: "Soumission progressive des annonces",
    SMART_AD_SUBMISSION: "Soumission intelligente des annonces",
    DEFAULT_AD_REGISTRATION: "Enregistrement d'annonces par défaut",
    AD_ANALYZER: "Analyseur de visites d'annonces",
    ADD_AD_PHOTO: "Ajouter une photo d'annonce",
    SMART_LADDER: "Échelle intelligente",
    GRADUAL_LADDER: "Échelle progressive",
    ADS_LIST: "Liste des annonces",
    AD_REPORTS: "Rapports d'annonces",
    SCHEDULED_AD_SUBMISSION: "Soumission d'annonces planifiées",
    SCHEDULED_AD_LIST: "Liste des annonces planifiées",
    PERSONAL_AD_SUBMISSION: "Soumission d'annonces personnelles",
    TARGET_TOOLS: "Outils ciblés",
    SMART_LIST: "Liste intelligente/progressive",
    // SMS
    SEND_TO_CUSTOMER_CLUB: "Envoyer au club client",
    BULK_SMS: "SMS en masse",
    LIVE_SMS: "SMS en direct (ancien)",
    SEND_TO_BUSINESSES: "Envoyer aux entreprises nationales",
    SMS_BY_MAP: "SMS depuis la carte",
    CITY_PROVINCE_SMS: "SMS ville et province",
    RECEIVED_SMS_LIST: "Liste des SMS reçus",
    SMS_TEXT_CONSULTANT: "Moniteur de consultant de texte SMS",
    DEFAULT_TEXT_CONSULTATION: "Texte par défaut + Consultation",
    ADMIN_SMS_SUBMISSIONS: "Soumissions admin",
    PENDING_SMS: "SMS en attente",
    ADMIN_RECEIVED_REPORT: "Rapport de réception admin",
    PATTERN: "Modèle/Template",
    SMS_REPORTS: "Rapports de soumission",
    DEDICATED_LINE_REQUESTS: "Demandes de ligne dédiée",
    PHONEBOOK: "Carnet d'adresses",
    SMS_TARIFFS: "Tarifs SMS",
    LINE_CATEGORIES: "Catégories de lignes",
    TARIFF_COEFFICIENTS: "Coefficients de tarifs",
    SEND_ADMIN_SMS: "Envoyer SMS admin",
    // Numbers and Contacts
    ADD_NEW_NUMBER: "Ajouter un nouveau numéro",
    NUMBERS: "Numéros",
    USER_NUMBERS: "Numéros d'utilisateur",
    REGISTER_USER_NUMBER: "Enregistrer un numéro pour l'utilisateur",
    NUMBER_LIST: "Ma liste de numéros",
    CREATE_NUMBER_TARIFF: "Créer un tarif de numéro",
    NUMBER_TARIFF_LIST: "Liste des tarifs de numéro",
    OTHER_TARIFF_LIST: "Autre liste de tarifs",
    // Financial Management
    WALLET: "Nouveau portefeuille",
    TRANSFER_REQUESTS: "Demandes de retrait",
    DIVAR_PAYMENTS: "Paiements Divar",
    AUTO_PAYMENT: "Paiement automatique",
    PAYMENTS: "Paiements",
    PAYMENT_GATEWAY: "Passerelle de paiement",
    BUY_CHARGE: "Acheter du crédit",
    // Customer and User Management
    CUSTOMERS: "Clients",
    CRM_CUSTOMERS: "Clients CRM",
    CONTACT_LIST: "Assistant de contact (Merci pour l'appel)",
    USERS: "Liste des utilisateurs",
    USER_REQUESTS: "Demandes d'utilisateur",
    PROFILE: "Profil",
    USER_HISTORY_NOTIFICATIONS: "Notifications d'historique utilisateur",
    // Design and Content
    WEBSITE_DESIGN_ORDER: "Commande de conception de site web",
    SEO_ORDER: "Commande SEO",
    BUY_INFO_DATABASE: "Acheter la base de données d'informations",
    BUY_MOBILE_DATABASE: "Acheter la base de données mobile",
    PURCHASED_ARCHIVES: "Archives achetées",
    FAVORITE_ARCHIVES: "Archives favorites",
    UPLOAD_CENTER: "Centre de téléchargement",
    CONTENT: "Contenu",
    // Management and Settings
    MONITORING: "Surveillance",
    MANAGEMENT: "Gestion",
    SETTINGS: "Paramètres",
    CATEGORIES: "Catégories",
    DOMAINS: "Domaines",
    REMINDERS: "Rappels",
    AUTOMATIC_CREATION: "Création automatique",
    PERMISSIONS: "Permissions",
    ROLES: "Rôles",
    MENUS: "Menus",
    CORE_MANAGEMENT: "Gestion principale",
    WORK_REPORTS: "Gestion des rapports de travail",
    WORK_REPORT_CREATE: "Rapport de travail",
    DEPARTMENTS: "Départements",
    DISCOUNTS: "Réductions",
    NOTIFICATIONS: "Notifications",
    ADMIN_NOTIFICATIONS: "Notifications admin",
    TICKET_MANAGEMENT: "Gestion des tickets",
    USER_GUIDE: "Guide utilisateur",
    CAMPAIGN: "Campagne",
    MESSAGE_CATEGORIES: "Catégories de messages",
    REGISTERED_INFO_LIST: "Liste des informations enregistrées",
    TARIFFS: "Tarifs",
    INFORMATION_REGISTRATION: "Enregistrement d'informations",
    UNCREATED_CARDS: "Cartes non créées",
    MODELS_LIST: "Liste des modèles",
    CREATE_DEFAULT_PRODUCT: "Créer un produit par défaut",
    EXCEL_FILES: "Fichiers Excel",
    AUTO_CHATS: "Chat intelligent",
    AUTO_CHAT: "Chat automatique",
    // Other
    MY_FILES: "Mes fichiers",
    CONSULTANTS: "Consultants",
    ADD_DIVAR_NEWS: "Ajouter des mises à jour Divar",
    BUY_PANEL: "Acheter un panneau",
    PANELS: "Panneaux",
    CALL_MONITORING: "Surveillance des appels",
    INFO_REVIEW: "Revue des informations",
    MESSAGES: "Messages",
    PERSONNEL: "Personnel",
    //qr
    QR_TOOL: "Outils QR",
    CREATE_DYNAMIC_QR: "Créer un QR dynamique",
    QR_MANAGEMENT: "Gestion QR",
    QR_MONITORING: "Surveillance QR",
    MY_QR_LIST: "Ma liste QR",
    PHYSICAL_NFC_ORDERS: "Commandes de cartes physiques et NFC",
    BULK_QR_GENERATION: "Génération de QR en masse",
    IMAGE_CREATION_TOKEN: "Token de création d'image",
    CATEGORIES: "Catégories",
    CREATE_DEFAULT_PRODUCT: "Créer un produit par défaut",
    DOMAINS: "Domaines",
    REMINDERS: "Rappels",
    AUTOMATIC_CREATION: "Création automatique",
    SEND_ADMIN_SMS: "Envoyer SMS admin",
    UNCREATED_CARDS: "Cartes non créées",
    MODELS_LIST: "Liste des modèles",
    UPLOAD_CENTER: "Centre de téléchargement",
    INFORMATION_REGISTRATION: "Enregistrement d'informations",
    TARIFFS: "Tarifs",
    REGISTERED_INFO_LIST: "Liste des informations enregistrées",
    //code
    personel: "Personnel",
    "workReports/create": "Rapport de travail",
    "admin/user-guide": "Guide utilisateur",
    phonebook: "Club client",
    contactlist: "Assistant de contact (Merci pour l'appel)",
    "contact/list": "Assistant de contact (Merci pour l'appel)",
    "admin/transferRequests": "Demandes de retrait",
    "admin/wallet": "Nouveau portefeuille",
    "admin/cdr": "Surveillance des appels",
    "admin/campaign": "Campagne",
    "admin/message-categories": "Catégories de messages",
    "admin/customers": "Clients CRM",
    "admin/notifications": "Notifications admin",
    "admin/user-history/notifications":
      "Notifications d'historique utilisateur",
    "admin/messages": "Messages",
    profile: "Profil",
    "admin/workReports": "Gestion des rapports de travail",
    panel: "Acheter un panneau",
    adminDiscounts: "Réductions",
    departments: "Départements",
    adminTickets: "Gestion des tickets",
    "admin/configs": "Paramètres",
    notifications: "Notifications",
    "user/confirmed": "Demandes d'utilisateur",
    users: "Liste des utilisateurs",
    payments: "Passerelle de paiement",
    permission: "Permissions",
    panels: "Panneaux",
    category: "Menus",
    content: "Contenu",
    role: "Rôles",
    "core/admin": "Gestion principale",
    //robot
    numberList: "Ma liste de numéros",
    registerAd: "Enregistrer une annonce",
    proPanelSendAd: "Soumission d'annonces de panneau professionnel",
    buyCharge: "Acheter du crédit",
    scheduledAdSend: "Soumission d'annonces planifiées",
    smartGradual: "Intelligent/Progressif",
    createNumberTariff: "Créer un tarif de numéro",
    numberTariffList: "Liste des tarifs de numéro",
    otherTariffList: "Autre liste de tarifs",
    userNumbers: "Numéros d'utilisateur",
    numbers: "Numéros",
    management: "Gestion",
    settings: "Paramètres",
    registerUserNumber: "Enregistrer un numéro pour l'utilisateur",
    divarPayments: "Paiements Divar",
    autoPayment: "Paiement automatique",
    adAnalyzer: "Analyseur de visites d'annonces",
    infoReview: "Revue des informations",
    rb_payments: "Paiements",
    autoChat: "Chat automatique",
    ads: "Annonces",
    monitoring: "Surveillance",
    smartLadder: "Échelle intelligente",
    gradualLadder: "Échelle progressive",
    excelFiles: "Fichiers Excel",
    autoChats: "Chat intelligent",
    addAdPhoto: "Ajouter une photo d'annonce",
    targetTools: "Outils ciblés",
    smartList: "Liste intelligente/progressive",
    scheduledAdList: "Liste des annonces planifiées",
    adsList: "Liste des annonces",
    adReports: "Rapports d'annonces",
    personalAdSend: "Soumission d'annonces personnelles",
  },
  AUTO_REFRESH_POPUP: {
    TITLE: "Entrez l'heure souhaitée :",
    SUBTITLE:
      "Après avoir défini l'heure, cette page sera toujours actualisée à l'intervalle sélectionné.",
    TIME_LABEL: "Heure",
  },
  MODAL: {
    OK_TITLE: "Confirmer",
  },

  ROUTE: {
    TITLES: {
       "QR_NAME_EDIT_GIFT": "Geschenk-QR-Code bearbeiten",
       "QR_GIFT": "Geschenk-QR-Code",
      QR_CARD_VISIT_PRO:"Pro-Visitenkarte",
      "QR_NAME_EDIT_PRO": "Edit Pro Pro-Visitenkarte",
      "QR_LINK_EDIT_PRO": "SEO Klick-Assistent QR bearbeiten",
      "QR_LINK_PRO": "SEO Klick-Assistent QR",
      DIGI: "Suivi des prix Digikala",
      QR_PDF: "Galerie PDF",
      QR_NAME_EDIT_PDF: "Modifier la galerie PDF",
      QR_MULTICART: "Carte QR multiple",
      QR_MULTICART_EDIT: "Modifier la carte QR multiple",
      QR_PRODUCTPRO: "Présentation de produit (Pro)",
      QR_NAME_PRODUCTPRO: "Modifier la présentation de produit (Pro)",
      QR_NAME_EDIT_CATALOG: "Modifier le catalogue",
      QR_LUCK_WHEEL_Edit: "Modifier la roue de la fortune",
      QR_LUCK_WHEEL: "Créer un QR de roue de la fortune",
      // -------------------------------------
      DASHBOARD: "Tableau de bord",
      ADMIN_QR_DOMAINS: "Surveillance des domaines",
      ADMIN_TOGETHER_TOKEN: "Surveillance des tokens",
      ADMIN_QR_SMS: "Envoyer SMS",
      MENU_PROFILE_INFO: "Informations utilisateur",
      MENU_PROFILE_SETTING: "Paramètres du profil",
      MENU_PROFILE_ORDERS: "Commandes",
      MENU_PROFILE_ADDRESSES: "Adresses",
      QR_MONITORING: "Surveillance QR",
      QR_LIST: "Ma liste QR",
      QR_NAME_LIST: "Gestion de participation",
      QR_GENERATE_MULTIPLE: "Génération de QR en masse",
      QR_CARD_VISIT: "Créer une carte de visite",
      HELP_INFO: "Bouton de test",
      QR_MENU: "Menu du magasin",
      QR_APPOINTMENT: "Réservation de rendez-vous",
      QR_INSURANCE: "Créer une assurance en ligne",
      QR_BPAGE: "Créer une page d'entreprise",
      QR_CPAGE: "Créer un site de complexe commercial/administratif",
      QR_BSHOP: "Boutique en ligne",
      QR_NAME_EDIT_BSHOP: "Modifier la boutique en ligne",
      QR_LINK_EDIT: "Modifier le lien",
      QR_NAME_DESIGN: "Modifier le design",
      QR_NAME_SETTING: "Modifier les paramètres",
      QR_NAME_EDIT: "Modifier la carte de visite",
      QR_NAME_EDIT_BPAGE: "Modifier la page d'entreprise",
      QR_EDIT_CPAGE: "Modifier le site de complexe commercial/administratif",
      QR_NAME_INSURANCE: "Modifier l'assurance en ligne",
      QR_NAME_EDIT_MENU: "Modifier le menu",
      QR_NAME_EDIT_APPLICATION: "Fournir l'application",
      QR_NAME_EDIT_APPOINTMENT: "Modifier la réservation de rendez-vous",
      QR_NAME_EDIT_PHOTO: "Modifier la galerie photo",
      QR_NAME_EDIT_VIDEO: "Modifier la galerie vidéo",
      QR_NAME_EDIT_VOICE: "Modifier la galerie audio",
      QR_NAME_EDIT_FEEDBACK: "Modifier la galerie de retours",
      QR_NAME_CONSULTATION_QR_EDIT: "Modifier le formulaire de demande",
      QR_NAME_EDIT_VOICE_PRO: "Modifier la galerie audio (Pro)",
      QR_NAME_EDIT_SOCIAL: "Modifier les réseaux sociaux",
      QR_NAME_STATISTICS: "Statistiques du code QR",
      QR_CATE: "Sélectionner la catégorie",
      QR_SHARE: "Partager",
      QR_BUSINESS_SHOP: "Entreprise/Magasin",
      QR_CO_ORGAN: "Entreprise/Organisation",
      QR_CONTACT: "Contact client",
      QR_NOTICES: "Notifications",
      QR_OTHERS: "Divers",
      QR_STATICS: "QR statique",
      QR_DYNAMICS: "QR dynamique",
      QR_D_BUSINESS: "QR d'entreprise dynamique",
      QR_D_ORGANS: "QR organisationnel dynamique",
      QR_D_GOVERNMENT: "QR gouvernemental dynamique",
      QR_VIDEO: "Galerie vidéo",
      QR_APPLICATION: "Fournir l'application",
      QR_VOICE: "Galerie audio",
      QR_VOICE_PRO: "Galerie audio (Pro)",
      QR_CONSULTATION_QR: "Formulaire de demande",
      QR_FEEDBACK: "Galerie de retours",
      QR_PHOTO: "Galerie photo",
      QR_CATALOG: "Catalogue / Brochure",
      QR_LOCATION: "Créer un QR d'emplacement",
      QR_SOCIAL_MEDIA: "Créer un QR de réseaux sociaux",
      QR_LINK: "Créer un lien",
      QR_TEXT: "Créer un texte",
      QR_MAIL: "Créer un e-mail",
      QR_CALL: "Appel",
      QR_SMS: "SMS",
      QR_WHATSAPP: "WhatsApp",
      QR_SITE: "Site web",
      QR_INSTAGRAM: "Instagram",
      QR_SKYPE: "Skype",
      QR_WIFI: "WiFi",
      QR_BUSINESS: "Page d'entreprise",
      QR_DISCOUNT: "Page de réduction",
      QR_PRODUCT_SHOP: "Présentation de produit",
      QR_PRODUCT_LABEL: "Étiquette de produit",
      QR_GOLD_LABEL: "Étiquette d'or",
      QR_PRODUCT_TEMPLATE: "Produits",
      ADMIN_CATEGORY: "Catégories",
      QR_NFC_ORDERS: "Cartes NFC en attente d'approbation",
      QR_NAME_PRODUCT: "Modifier la présentation de produit",
      QR_NAME_LABELPRODUCT: "Modifier l'étiquette de produit",
      QR_NAME_GOLDPRODUCT: "Modifier l'étiquette d'or",
      QR_COINS: "Cryptomonnaies",
      QR_SHOP: "Gestion du magasin",
      QR_TWITTER: "Twitter",
      UPLOAD_CENTER: "Centre de téléchargement",
      PRICING: "Tarifs QR",
      QR_CREATE_MODELS: "Créer un modèle de carte de visite",
      QR_CREATE_BUSINESS_MODELS: "Créer un modèle de page d'entreprise",
      QR_CREATE_PRODUCT_MODEL: "Créer un modèle de carte produit",
      QR_CREATE_MENU_MODELS: "Créer un modèle de menu de magasin",
      QR_CREATE_SHOP_MODEL: "Créer un modèle de boutique en ligne",
      MODELS_LIST: "Types de modèles QR",
      MODELS_LIST_EDIT: "Modifier le modèle",
      MODELS_LIST_MENU_EDIT: "Modifier le modèle de menu",
      MODELS_LIST_BMODEL_EDIT: "Modifier le modèle de boutique en ligne",
      NFC: "Cartes NFC",
      SUBMIT_FORM: "Enregistrer un blogueur",
      REQUEST_LIST: "Liste des blogueurs",
      PURE_DATA: "Liste des cartes de visite non créées",
      AUTO_CREATE: "Création automatique de QR",
      QR_CREATE: "Créer un QR",
      HISTORY_REMINDER: "Surveillance des rappels",
      BOOK: "Surveillance des rappels"
    },
  },
  qr_management: "Gestion QR",
  router: {
    dashboard: "Tableau de bord",
    contacts: "Club client",
    editContact: "Modifier le client",
    createContact: "Créer un client",
    customers: "Liste des clients",
    contactList: "Assistant de contact",
    messages: "Messages",
    messageCategories: "Catégories de messages",
    oldTransactions: "Anciennes transactions",
    yourTransactions: "Vos transactions",
    buyPanel: "Acheter un panneau",
    permissions: "Permissions",
    createPermission: "Créer une permission",
    invitations: "Ma liste d'invitations",
    editUser: "Modifier l'utilisateur",
    userInformation: "Voir les informations utilisateur",
    walletEdit: "Modifier les informations du portefeuille utilisateur",
    userHistory: "Historique utilisateur",
    userNotificationsHistory: "Historique des notifications utilisateur",
    notifications: "Notifications",
    createNotification: "Créer une notification",
    editNotification: "Modifier la notification",
    adminNotifications: "Notifications admin",
    yourNotifications: "Vos notifications",
    adminNotificationsList: "Notifications admin",
    tickets: "Tickets",
    createTicket: "Enregistrer un nouveau ticket",
    editTicket: "Modifier le ticket",
    departments: "Départements",
    createDepartment: "Nouveau département",
    editDepartment: "Modifier le département",
    adminTickets: "Gestion des tickets",
    discounts: "Réductions",
    createDiscount: "Créer une réduction",
    editDiscount: "Modifier la réduction",
    workReports: "Rapports de travail",
    createWorkReport: "Créer un rapport de travail",
    callMonitoring: "Surveillance des appels",
    adminWorkReports: "Gestion des rapports de travail",
    editWorkReport: "Voir et modifier le rapport de travail",
    packProperties: "Caractéristiques du forfait",
    createPackProperty: "Créer une caractéristique de forfait",
    editPackProperty: "Modifier une caractéristique de forfait",
    panels: "Panneaux",
    createPanel: "Créer un panneau",
    editPanel: "Modifier le panneau",
    transferRequests: "Demandes de retrait",
    editTransferRequest: "Modifier la demande de retrait",
    tariffs: "Tarifs",
    createTariff: "Créer un tarif",
    editTariff: "Modifier le tarif",
    requests: "Demandes",
    viewUser: "Voir l'utilisateur",
    manageTransactions: "Gérer les transactions",
    viewTransaction: "Voir la transaction",
    manageConfigs: "Gérer les paramètres",
    rbLandConfigs: "Gérer les paramètres de Robot Land",
    editConfig: "Modifier les paramètres",
    manageUsers: "Gérer les utilisateurs",
    categories: "Catégories",
    createCategory: "Ajouter une catégorie",
    editCategory: "Modifier la catégorie",
    content: "Contenu",
    createContent: "Ajouter du contenu",
    editContent: "Modifier le contenu",
    addUserGuide: "Ajouter un guide utilisateur",
    editUserGuide: "Modifier le guide utilisateur",
    roles: "Rôles",
    editRole: "Modifier le rôle",
    createRole: "Ajouter un rôle",
    permissionTitle: "Permissions",
    paymentGateways: "Passerelles de paiement",
    editPaymentGateway: "Modifier les passerelles de paiement",
    campaigns: "Campagnes",
    createCampaign: "Créer une campagne",
    editCampaign: "Modifier les informations de la campagne",
    adminCustomers: "Clients",
    createCustomer: "Créer des clients",
    editCustomerInfo: "Modifier les informations client",
    referrerCustomers: "Clients référents",
    customerHistory: "Historique client",
    userProfile: "Profil utilisateur",
    editProfile: "Modifier le profil",
    inviteFriends: "Inviter des amis",
    personalInfo: "Informations personnelles",
    editPersonalInfo: "Modifier les informations",
    changePassword: "Changer le mot de passe",
    newWallet: "Nouveau portefeuille",
  },
  ticket: {
    text: "Enregistrer un ticket",
  },
};
